export default __webpack_public_path__ + "static/assets/6113622464c23447511567641cfbed53.png";